import React, { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getUserInfo } from "../../api/auth";

const Cancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
  	// トークン復元処理
const persisted = sessionStorage.getItem("persist_token");
if (!sessionStorage.getItem("token") && persisted) {
  sessionStorage.setItem("token", persisted);
  sessionStorage.removeItem("persist_token");
}
  
  
    const token = sessionStorage.getItem("token");
    if (token) {
      getUserInfo().then(data => {
      }).catch(err => {
      });
    }
  }, []);

  return (
    <Box p={4} maxWidth="600px" mx="auto" textAlign="center">
      <Typography variant="h4" gutterBottom>
        お手続きがキャンセルされました
      </Typography>
      <Typography variant="body1" gutterBottom>
        プランの変更は行われませんでした。もう一度お試しください。
      </Typography>
      <Button
        variant="outlined"
        sx={{ mt: 3 }}
        onClick={() => navigate("/settings/plan")}
      >
        プラン設定に戻る
      </Button>
    </Box>
  );
};

export default Cancel;
